const STICKY_CLASS = 'sticky'
const CALCULATING_CLASS = 'calculating'

class StatisticsStickyFilters {
    constructor(element) {
        if (!element) return

        this.element = element
        this.mobOpenBtn = this.element.querySelector('.b-statistics-filters__mob-toggler .e-btn')
        this.mobCloseBtn = this.element.querySelector('.b-statistics-filters__close')
        this.filtersCont = this.element.querySelector('.b-statistics-filters__cont')

        this._setPlaceholderHeight()

        this._iniMobToggler()

        setTimeout(() => {
            this.checkStickyPosition()
        })

        window.addEventListener('resize', () => {
            this._setPlaceholderHeight()

            setTimeout(() => {
                this.checkStickyPosition()
            })
        })

        window.addEventListener('scroll', () => {
            this.checkStickyPosition()
        })
    }

    _iniMobToggler() {
        this.mobOpenBtn.addEventListener('click', () => {
            this.openMobFilters()
        })

        this.mobCloseBtn.addEventListener('click', () => {
            this.closeMobFilters()
        })
    }

    openMobFilters() {
        this.mobOpenBtn.style.display = 'none'
        $(this.filtersCont).slideDown()
    }

    closeMobFilters() {
        $(this.filtersCont).slideUp(300, () => {
            $(this.mobOpenBtn).fadeIn(200)
        })
    }

    _setPlaceholderHeight() {
        this.element.classList.add(CALCULATING_CLASS)
        this.element.parentNode.style.height = `${this.element.offsetHeight}px`
        this.element.classList.remove(CALCULATING_CLASS)
    }

    checkStickyPosition() {
        if (!document.querySelector('.s-statistics__main')) {
            return
        }

        const scrollTop = window.pageYOffset
        const resultsStart = $('.s-statistics__main').offset().top

        scrollTop > resultsStart - 200
            ? this.element.classList.add(STICKY_CLASS)
            : this.element.classList.remove(STICKY_CLASS)
    }
}

export default StatisticsStickyFilters
